export default __webpack_public_path__ + "static/apply-2ca06efb199acf5f8089e2a22298ff89.png";